import authHeader from "./auth-header";
import axios from "../Axios";

export default {
  async login(user) {
    try {
      var response = await axios.post(`/auth/login`, {
        username: user.username,
        password: user.password,
      });

      if (response.data && response.data.data) {
        const userData = response.data.data;
        console.log("Login response data:", userData);

        if (userData.token) {
          if (typeof userData.token === "string") {
            localStorage.setItem("user_free", userData.token);
          } else {
            localStorage.setItem("user_free", JSON.stringify(userData.token));
          }
          console.log("Token stored in localStorage");
        }
        return userData;
      }
      return null;
    } catch (error) {
      console.error("Login error:", error.response?.data || error.message);
      throw error;
    }
  },

  async logout() {
    const token = localStorage.getItem("user_free");
    if (token) {
      try {
        await axios.post(`/auth/logout`, {}, { headers: authHeader() });
      } catch (error) {
        if (error.response && error.response.status === 401) {
          console.log("Token is expired or invalid, clearing local storage...");
        } else {
          console.error("Logout error:", error.response?.data || error.message);
          throw error;
        }
      }
    }
    localStorage.removeItem("user_free");
  },
};
